import { AppRouteCreators } from '../types/core'
import { EnumLiteralsOf } from '../types/helpers'

export const Adzones = {
  eval: 'eval',
  folders: 'folders',
  form: 'form',
  homepage: 'homepage',
  search: 'search',
  searchResults: 'searchresults',
  source: 'source',
  view: 'view',
  empty: 'empty',
  none: '',
} as const

export type Adzone = EnumLiteralsOf<typeof Adzones>

type RouteToAdzoneMap = Partial<Record<keyof AppRouteCreators, Adzone>>

export const routeToAdzoneMap: RouteToAdzoneMap = {
  toCitationsHome: Adzones.homepage,
  toProfile: Adzones.empty,
  toLogout: Adzones.empty,
  toUpgrade: Adzones.empty,
  toSignup: Adzones.empty,
  toLogin: Adzones.empty,
  toGateway: Adzones.homepage,
  toSourceTypeSelection: Adzones.source,
  toSourceSearch: Adzones.search,
  toSourceSelection: Adzones.searchResults,
  toSourceConfirmation: Adzones.eval,
  toNewCitation: Adzones.form,
  toManualCitation: Adzones.form,
  toEditCitation: Adzones.form,
  toBibliography: Adzones.view,
  toProject: Adzones.view,
  toFolders: Adzones.folders,
  toDashboard: Adzones.empty,
} as const
